import { PaymentConfig } from 'src/app/model/paymentConfig';
import { SupabaseCreds } from '../app/model/supabaseCreds';

const supabaseCreds: SupabaseCreds[] = [
  {
    accountId: 'sg-live-account',
    supabaseProjectUrl: 'https://yjsyxgoqbxohyogsuktm.supabase.co',
    supabaseKey:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inlqc3l4Z29xYnhvaHlvZ3N1a3RtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjAyNTg1MjYsImV4cCI6MjAzNTgzNDUyNn0.kH8QJ23bbscXR6hJCxpr_5fJthf0CY87XHga547NjlM',
    googleLoginKeys:
      '193773163724-i6j07h6kkbcr6t7hf9fka77ht9r9nuc1.apps.googleusercontent.com'
  },
  {
    accountId: 'bmc-live-account',
    supabaseProjectUrl: 'https://eugzpgrahebtgocvlgxu.supabase.co',
    supabaseKey:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImV1Z3pwZ3JhaGVidGdvY3ZsZ3h1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjExMTUwNzgsImV4cCI6MjAzNjY5MTA3OH0.2zWXoCZv5-PMXhzAMJwNSKtBFWgJzn8T7oLN7Pd6t54',
    googleLoginKeys:
      '126945708063-0ugdbpc2ebtjp2vjmrabt9972ttqfeo4.apps.googleusercontent.com'
  },
  {
    accountId: 'er-live-account',
    supabaseProjectUrl: 'https://fsipvvozjsphuivjvsym.supabase.co',
    supabaseKey:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZzaXB2dm96anNwaHVpdmp2c3ltIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MjYyNDE5MzgsImV4cCI6MjA0MTgxNzkzOH0.0QMLdznXLKNPMlQ8D490IhcJMDUiWconXuwLT-zZiZc',
    googleLoginKeys:
      '314678089202-1hcesmhqbe101uoqhts64csrtnascp28.apps.googleusercontent.com'
  },
  {
    accountId: 'hostmytrip-live-account',
    supabaseProjectUrl: 'https://uixshtiyernrzouhxbht.supabase.co',
    supabaseKey:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVpeHNodGl5ZXJucnpvdWh4Ymh0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzMxMTgzNTMsImV4cCI6MjA0ODY5NDM1M30.tmquytse7VCDfxCBTgiNHF_R39ngqYvJG-DLb5sSYAs',
    googleLoginKeys:
      '667544359342-f0jd3v53pnqn9flbiusthfnsdfme28r7.apps.googleusercontent.com'
  },
  {
    accountId: 'hotelusso-live-account',
    supabaseProjectUrl: 'https://gmpyfshqwzphvvrkscqy.supabase.co',
    supabaseKey:
      'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdtcHlmc2hxd3pwaHZ2cmtzY3F5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ3ODk4NDQsImV4cCI6MjA2MDM2NTg0NH0.50WqJXO8lNA7_gn5OtAwg0BXL2IC-YDacae7X8YU8Y8',
    googleLoginKeys: ''
  },
  {
    accountId: 'secretescapades-live-account',
    supabaseProjectUrl: 'https://olnnjvqikjcglragmayx.supabase.co',
    supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9sbm5qdnFpa2pjZ2xyYWdtYXl4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDY1MjA1NzAsImV4cCI6MjA2MjA5NjU3MH0.fAV2CHzhmugp4OE7bJ4M0IOIzWLXFGmWs3XyJtCOHmg',
    googleLoginKeys: ""
  },
  {
    accountId: 'alldotgay-live-account',
    supabaseProjectUrl: 'https://gobghwqlwntuoujtdgzq.supabase.co',
    supabaseKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImdvYmdod3Fsd250dW91anRkZ3pxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODQ4NjMxMzEsImV4cCI6MjEwMDQzOTEzMX0.hZwvbB9OcMWL8rwwldxQzsKIIiqBIbu26cZ0ki6YVb4',
    googleLoginKeys: ""
  }
];

const paymentConfig: PaymentConfig[] = [
  {
    accountId: 'hostmytrip-live-account',
    providerName: "easebuzz"
  },
  {
    accountId: 'dreampass-live-account',
    providerName: "connexpay"
  },
  {
    accountId: 'trevolutionb2c-live-account',
    providerName: "connexpay"
  },
  {
    accountId: 'reckit-corporate-live-account',
    providerName: "stripe"
  }
]

export const environment = {
  production: false,
  apiUrl: 'https://gar-portalapi.us.prod.zentrumhub.com/',
  Auth0clientID: 'FpLfDyjE768Nj7Q9KOdGA3yDOJoFAB5u',
  Auth0domain: 'zentrumhub.us.auth0.com',
  perNightPrice: true,
  countryOfResidence: 'US',
  nationality: 'US',
  peachPamentScript: 'https://checkout.peachpayments.com/js/checkout.js',
  supabaseCreds: supabaseCreds,
  paymentConfig: paymentConfig,
  stripePassKey: 'u$y4t-d@n3z8b-2&7a3'
};
